module.exports = __webpack_public_path__ + "static/media/Dino_1.2c3c30b8.jpg";